import React from 'react';
import { inspectionFlow } from '../data/content';
export function SystemOverview() {
  return <section className="bg-carbon px-3 py-4 text-white sm:px-6" data-id="element-147" data-mp="18vski2oh9av8">
      <div className="mx-auto max-w-2xl text-center" data-id="element-148" data-mp="18tg3brqjn4j8">
        <h2 className="font-display text-[1.5rem] font-bold uppercase leading-none sm:text-[2.1rem]" data-id="element-149" data-mp="1mlmawpfms372">
          EVERYTHING YOU NEED. <span className="text-safety" data-id="element-150" data-mp="1hocl38obxpip">ONE COMPLETE SAFETY INSPECTION SYSTEM.</span>
        </h2>
        <p className="mt-1 text-[0.78rem] font-semibold text-mist sm:text-[0.92rem]" data-id="element-151" data-mp="ty9y36z9v9qy">
          6 Professional Safety Inspection Resources In One Organized System
        </p>
        <p className="mt-2 font-display text-[1.15rem] font-bold uppercase tracking-wide text-safety sm:text-[1.4rem]" data-id="element-152" data-mp="13x7lg6kyox8d">
          🦺 SAFETY INSPECTION PRO™
        </p>
        <p className="mt-1 text-[0.78rem] leading-[1.4] text-white/85 sm:text-[0.92rem]" data-id="element-153" data-mp="2fb2y98oe8twf">
          SAFETY INSPECTION PRO™ brings inspection planning, hazard identification, workplace and
          equipment checklists, risk assessment, professional reporting, corrective-action tracking
          and follow-up resources together in one organized system.
        </p>
        <p className="mt-2 inline-block rounded border border-steel bg-graphite px-2.5 py-1 text-[0.58rem] font-extrabold uppercase tracking-[0.04em] text-white sm:text-[0.8rem]" data-id="element-154" data-mp="287jyatj99wyp">
          {inspectionFlow.map((step, i) => <React.Fragment key={step} data-id="element-155" data-mp="1kg4tmu40b3ka" data-mpi={i}>
              {i > 0 ? <span className="text-warning" data-id="element-156" data-mp="1khfwmrpmo7ac"> → </span> : null}
              {step}
            </React.Fragment>)}
        </p>
      </div>
    </section>;
}